import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoading, selectServices } from '../../store/selectors/my-bills.selectors';
import { loadPayerServices } from '../../store/actions/my-bills.actions';
import { SigIdPayerServiceListItem } from '../../services/sig-id.common.model';
import { AlertComponent } from '../../common/alert/alert.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../components/content/content.component';
import { CommonModule, DatePipe } from '@angular/common';
import { FilterDataPipe } from '../../pipes/filter-data.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { RouterLink } from '@angular/router';
import { SessionService } from '../../services/ssession.service';

@Component({
  selector: 'app-my-bills-page',
  standalone: true,
  imports: [
    AlertComponent,
    BreadcrumbsComponent,
    ContentComponent,
    DatePipe,
    FilterDataPipe,
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    FormsModule,
    RouterLink
  ],
  templateUrl: './my-bills-page.component.html'
})
export class MyBillsPageComponent implements OnInit {

  public authed: boolean = SessionService.Authed();

  private store$: Store = inject(Store);

  public filterValue: string = '';

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public services: Signal<SigIdPayerServiceListItem[]> = this.store$.selectSignal(selectServices);

  public ngOnInit(): void {
    if (this.authed) {
      this.store$.dispatch(loadPayerServices({ force: true }));
    }
  }
}
